import useFeatureFlag, { gameQuestEventSelector } from '../store/featureFlag';
import links from '../constants/links';

export function useUploadingGameLink(): string {
  const gameQuestEvent: boolean = useFeatureFlag(gameQuestEventSelector);
  return gameQuestEvent ? links.gameQuestUploadGameLink : links.uploadingGameLink;
}
